import Axios from 'axios';
var OperationReportService = (function () {
    function OperationReportService() {
    }
    OperationReportService.prototype.getList = function (params) {
        return Axios.get('supplierclientapi/operation_report/list', { params: params });
    };
    OperationReportService.prototype.getSummaryList = function (params) {
        return Axios.get('supplierclientapi/operation_report/summary', { params: params });
    };
    OperationReportService.prototype.getAnasyleList = function (params) {
        return Axios.get('supplierclientapi/loss_analysis/list', { params: params });
    };
    OperationReportService.prototype.getAnasyleDetails = function (params) {
        return Axios.get('supplierclientapi/loss_analysis/detail', { params: params });
    };
    OperationReportService.prototype.getTriumphList = function (params) {
        return Axios.get('supplierclientapi/performance/list', { params: params });
    };
    OperationReportService.prototype.getTtiuphDetail = function (params) {
        return Axios.get('supplierclientapi/performance/detail_list', { params: params });
    };
    OperationReportService.createInstance = function () {
        OperationReportService.getInstance();
    };
    OperationReportService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return OperationReportService;
}());
export default OperationReportService;
